import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {AppCommunicationService} from './app-communication.service';
import {AuthenticationService} from './authentication.service';
import {Router} from '@angular/router';
import {
    getAllNotificationsForSystem,
    getDepartmentCodebookUrl,
    getDocumentCodebookUrl,
    getFacultyCodebookUrl,
    getPublicFaqUrl
} from '../app.urls';
import {SYSTEM_NAME} from '../app.settings';

@Injectable()
export class GeneralService {

    checkUnauthorizedAccess(error) {
        if (error.status === 401) {
            this.router.navigate(['/login']);
            return Observable.throw('Unauthorized');
        }
        return Observable.throw('error');
    }

    constructor(
        private _http: Http,
        private router: Router,
        private _authenticationService: AuthenticationService
    ) {
    }

    checkSystemMaintance(): Observable<boolean> {
        return Observable.of(true);
    }

    getFaculties(): Observable<any[]> {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        const requestOpt = new RequestOptions({headers: headers});

        if (this._authenticationService.checkUser()) {
            return this._http
                .get(getFacultyCodebookUrl(), requestOpt)
                .map(res => res.json().items)
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }

    getDepartments(facultyId: number): Observable<any[]> {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        const requestOpt = new RequestOptions({headers: headers});

        if (this._authenticationService.checkUser()) {
            return this._http
                .get(getDepartmentCodebookUrl(facultyId), requestOpt)
                .map(res => res.json().items)
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }
    getPublicFaqForIsbn(): Observable<any> {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        headers.append('Content-Type', 'application/json');
        const options = new RequestOptions({headers: headers});

        if (this._authenticationService.checkUser()) {
            return this._http
                .get(getPublicFaqUrl(), options)
                .map(res => res.json().items)
                .catch(e => {
                    return this.checkUnauthorizedAccess(e);
                });
        }
    }


    getNotifications(): Observable<any[]> {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        headers.append('Content-Type', 'application/json');
        const requestOpt = new RequestOptions({headers: headers});

        return this._http
            .post(getAllNotificationsForSystem(false, SYSTEM_NAME), {}, requestOpt)
            .map(res => res.json().items);
    }

    getDocumentCodebook(): Observable<any[]> {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + AppCommunicationService.getCurrentUser().access_token);
        headers.append('Content-Type', 'application/json');
        const requestOpt = new RequestOptions({headers: headers});

        return this._http
            .get(getDocumentCodebookUrl(), requestOpt)
            .map(res => res.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/general.service.ts